import tw from 'tailwind-styled-components'
import {Icon} from '@components/common/base/icon'
import {cn} from '@containers/html-utils'
import {ChatSystemMessageLayout, ChatSystemMessageType} from './types'
import {getBackground, getColor} from './utils'

export const TwChatSystemMessageContainer = tw.div<{$animateShow?: boolean}>`
  message-item-new
  w-full
  py-8
  px-24
  ${p => cn(p.$animateShow && 'opacity-0 animate-show-message')}
`

export const TwChatSystemMessage = tw.div<{
  $type: ChatSystemMessageType
  $layout: ChatSystemMessageLayout
}>`
  flex
  justify-center
  px-16
  py-8
  rounded-8
  gap-8
  ${p =>
    cn(
      getBackground(p.$type),
      getColor(p.$type),
      p.$layout === 'vertical' && 'flex-col text-center'
    )}
`

export const TwIcon = tw(Icon)`
  flex-none
  flex
  items-center
`

export const TwMessage = tw.div`
  flex-initial
  text-12
  leading-4
`

export const TwDateTime = tw.div<{$layout: ChatSystemMessageLayout}>`
  flex-none
  text-12
  leading-4
  ${p =>
    cn(
      p.$layout === 'vertical' && cn('-order-1', 'text-placeholder'),
      p.$layout === 'horizontal' && 'ml-auto'
    )}
`
